module.exports = __webpack_public_path__ + "img/mojopro.23491adb.png";